import { Paper } from "@mui/material"

const PopupPaper = ({children, style}) => {

    const baseStyle = {
        padding: "2rem 1rem 1rem 1rem", 
        boxSizing: "border-box"
    }

    return (
        <Paper sx={{
            ...baseStyle,
            ...style
        }} 
        className="p-2 d-flex flex-column gap-1 jc-center ai-center">
            {children}
        </Paper>
    )
}

export default PopupPaper;